import { roas } from '@/lib/money'
import { cn } from '@/lib/utils'

/** ROAS as a short bar (full at 3×) with its value: "2.95×". With no spend
 *  there is no ratio and it is a dash; `hidden` (spend that cannot come in —
 *  Ads refused or not linked) is a dash too, `hint` saying why to screen
 *  readers only (the screen says it once at its head). The bar
 *  is one colour: the value says whether it is good. */
export function RoasBar({
  value,
  cost,
  hidden,
  hint,
  className,
}: {
  value: number
  cost: number
  hidden?: boolean
  hint?: string | null
  className?: string
}) {
  const text = hidden ? '—' : roas(value, cost)
  const width = !hidden && cost > 0 ? Math.max(0, Math.min(100, (value / 3) * 100)) : 0
  return (
    <span
      className={cn('inline-flex items-center gap-1.5 whitespace-nowrap tabular-nums', className)}
      title={hidden ? undefined : `ROAS ${text} (막대는 3×에서 가득)`}
    >
      <span aria-hidden className="h-1.5 w-12 shrink-0 overflow-hidden rounded-full bg-muted">
        <span className="block h-full rounded-full bg-chart-1" style={{ width: `${width}%` }} />
      </span>
      <span className={cn('min-w-[3.25rem] text-right', text === '—' && 'text-muted-foreground')}>
        <span className="sr-only">ROAS </span>
        {text}
        {hidden && hint && <span className="sr-only"> {hint}</span>}
      </span>
    </span>
  )
}
